import React from "react";
import { sessions } from "../data/landing";
import { CtaButton } from "./CtaButton";
export function WorkshopsSection() {
  return <section className="section wash" id="workshops" data-id="element-307" data-mp="12mzmfgjf47pe">
      <div className="shell" data-id="element-308" data-mp="16pmi5sj7mcrv">
        <div className="section-intro" data-id="element-309" data-mp="16rfqrdddv72i">
          <p className="eyebrow" data-id="element-310" data-mp="16obfjw1i3b2c">THE COMPLETE SESSION COLLECTION</p>
          <h2 data-id="element-311" data-mp="1bopdgl9e14mn">
            Ten difficult conversations.
            <br data-id="element-312" data-mp="ezi0i1mu43uc" />
            <span data-id="element-313" data-mp="ezzuerm0y5z3">Ten sessions ready to run.</span>
          </h2>
          <p data-id="element-314" data-mp="j0jsbxef9dma">Run one session when a need comes up, or use the ten as a structured team practice program.</p>
        </div>
        <ol className="workshop-list" data-id="element-315" data-mp="nz4va4l26bef">
          {sessions.map((s, i) => <li key={s.title} data-id="element-316" data-mp="sqd4p0me1wrl" data-mpi={i}>
              <span className="workshop-number" data-id="element-317" data-mp="srephwt7hxmi">{String(i + 1).padStart(2, "0")}</span>
              <div data-id="element-318" data-mp="3rgwnnk33wxd5">
                <h3 data-id="element-319" data-mp="3rflmls11q3pq">{s.title}</h3>
                <p data-id="element-320" data-mp="3reaits7lovym">{s.text}</p>
              </div>
            </li>)}
        </ol>
        <div className="section-action" data-id="element-321" data-mp="896zhft9ybx">
          <CtaButton href="#offer-details" data-id="element-322" data-mp="1suje0u41psq7">Get all 10 sessions + 5 bonuses</CtaButton>
          <p className="cta-note" data-id="element-323" data-mp="1osekrwhiey43">$27 USD · One-time payment</p>
        </div>
      </div>
    </section>;
}